import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IAiEmbeddingVectorService = ( createDecorator('IAiEmbeddingVectorService'));
export { IAiEmbeddingVectorService };
